<div class="card card-redlaboral m-4">
    <div class="card-body">

        <div class="d-flex align-items-center mb-3">
            <i class="fa-solid fa-chart-column fs-3 text-primary me-3"></i>
            <div>
                <h4 class="mb-0">Inventario y Cupos</h4>
                <p class="text-muted mb-0">
                    Panel centralizado para monitorear inventario y cupos.
                </p>
            </div>
        </div>

        <hr />

        <div class="row align-items-end mb-3">
            <div class="col-md-3">
                <label class="form-label">Filtrar por Ítem</label>
                <input class="form-control" placeholder="Nombre del ítem" [(ngModel)]="filterName" />
            </div>

            <div class="col-md-3">
                <label class="form-label">Filtrar por tipo</label>
                <select class="form-select" [(ngModel)]="filterType">
                    <option value="ALL">Todos</option>
                    <option value="INVENTORY">Inventario</option>
                    <option value="SEATS">Cupos</option>
                </select>
            </div>

            <div class="col-md-3">

            </div>

            <div class="col-md-3 text-end">
                <button class="btn btn-primary me-2" (click)="applyFilters()">
                    <i class="fa-solid fa-sliders me-1"></i> Aplicar Filtros
                </button>
                <button class="btn btn-outline-secondary me-2" (click)="clearFilters()" title=" Limpiar Filtro">
                    <i class="fa-solid fa-eraser me-1"></i>
                </button>
                <button class="btn btn-success" (click)="exportCsv()">
                    <i class="fa-solid fa-file-csv me-1"></i> Exportar CSV
                </button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-theme align-middle">
                <thead class="table-light">
                    <tr>
                        <th>ÍTEM</th>
                        <th>TIPO</th>
                        <th>TOTAL / CAPACIDAD</th>
                        <th>RESERVADO / OCUPADO</th>
                        <th>DISPONIBLE</th>
                        <th>SALIDAS / CONFIRMACIONES</th>
                        <th class="text-center">ACCIONES</th>
                    </tr>
                </thead>

                <tbody>
                    @for (item of resources(); track item.versionId) {
                    <tr>
                        <td class="fw-semibold">{{ item.title }}</td>

                        <td>
                            @if (item.resourceType === 'INVENTORY') {
                            <span class="badge bg-primary">Inventario</span>
                            } @else {
                            <span class="badge bg-success">Cupos</span>
                            }
                        </td>

                        <td>
                            {{ item.inventoryEnabled ? item.initialStock : item.totalSeats }}
                        </td>

                        <td>{{ item.reservedQty }}</td>

                        <td class="fw-semibold" [class.text-danger]="item.availableQty === 0"
                            [class.text-success]="item.availableQty > 0">
                            {{ item.availableQty }}
                        </td>

                        <td>{{ item.confirmedQty }}</td>

                        <td class="text-center">
                            <a class="manage-link" (click)="manage(item)">
                                Gestionar
                            </a>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        <app-pagination [page]="page()" [pageSize]="pageSize()" [totalItems]="total()"
            (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
        </app-pagination>

    </div>
</div>

<app-modal-inventory-management (changeData)="load()"/>